import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Clock3, LogOut, ShieldCheck } from 'lucide-react';

export const PendingApprovalPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-blue-50 flex items-center justify-center p-6">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl border border-amber-100 p-8">
        <div className="flex items-center gap-4 mb-6">
          <div className="p-4 rounded-2xl bg-amber-100 text-amber-700">
            <Clock3 size={30} />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Approval Pending</h1>
            <p className="text-gray-600 mt-1">
              Your company registration has been submitted and is waiting for super admin approval.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-6">
          <div className="rounded-xl border border-gray-200 p-4">
            <p className="text-sm text-gray-500">Company</p>
            <p className="text-lg font-semibold text-gray-900">
              {user?.company?.companyName || 'Pending company'}
            </p>
            <p className="text-sm text-gray-600">{user?.company?.companyCode}</p>
          </div>
          <div className="rounded-xl border border-gray-200 p-4">
            <p className="text-sm text-gray-500">Registered Admin</p>
            <p className="text-lg font-semibold text-gray-900">{user?.fullName}</p>
            <p className="text-sm text-gray-600">{user?.email}</p>
          </div>
        </div>

        <div className="rounded-xl bg-blue-50 border border-blue-100 p-4 mb-6 flex gap-3">
          <ShieldCheck className="text-blue-700 flex-shrink-0 mt-0.5" size={20} />
          <div className="text-sm text-blue-900">
            You will be able to invite users and access company workflows after approval.
            Super admin reviews company details before activation.
          </div>
        </div>

        <button
          onClick={handleLogout}
          className="inline-flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-white hover:bg-gray-800 transition"
        >
          <LogOut size={18} />
          Sign out
        </button>
      </div>
    </div>
  );
};

